import React from 'react';
import styled from 'styled-components';

type ButtonSubmitComponentProps = {
  className?: string
  value: string
  width?: string
  height?: string
  submitting?: boolean
  submittingMessage?: string
}

const ButtonSubmitStyle = styled.input<{$width?: string, $height?: string}>`
  background: #393432;
  border: none;
  border-radius: 25px;
  color: white;
  cursor: pointer;
  font-size: 12px;
  width: ${props => props.$width || '50px'};
  height: ${props => props.$height || '50px'};

  :hover {
    background: #696767;
  }
`;

const ButtonSubmit: React.FC<ButtonSubmitComponentProps> = (
  {
    className,
    value,
    width,
    height,
    submitting,
    submittingMessage
  }) => {
  return (
    <ButtonSubmitStyle type='submit' value={submitting ? submittingMessage : value} className={className} $width={width} $height={height} disabled={submitting} />
  );
};

export default ButtonSubmit;
